import { useState, useContext, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";


// import useAxios from "../../components/useAxios";
import authAxios from "../../components/authAxios";

import DashboardHeader from "../../components/DashboardHeader";
import Pagination from '@mui/material/Pagination';
import { Card, CardContent } from "@mui/material";
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { useMediaQuery } from 'react-responsive'
// import AccountNew from "./AccountNew";
import CollectionNew from './CollectionNew'
import ThreeDotsMenu from "../../components/ThreeDotsMenu";

import { format } from 'date-fns';
import BrandNew from "./BrandNew";


// import { UserContext } from "../../App";


const Brands = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 750px)' })

    //Pagination
    const [page, setPage] = useState(1);
    const [pagecount, setPageCount] = useState();

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const convertDateTime = (myDateTime) => {
        return format(new Date(myDateTime), 'dd-MM-yyyy HH:mm');
      };

    const [isModalOpen, setIsModalOpen] = useState(false);
    // const {clientProfile} = useContext(UserContext);

    const { data: clientProfile } = useQuery({
        queryKey: ['clientProfile'],
        queryFn: async () => {
          const response = await authAxios.get(`/clientprofiles/${localStorage.getItem('clientProfile')}`);
          return response.data

        },
    });

    const { data: brands } = useQuery({
        queryKey: ['brands', page],
        queryFn: async () => {
          const response = await authAxios.get(`/products/brands/?page=${page}`);
          setPageCount(response.data.page_count)
          return response.data.results
        },
    });

    const threeSubMenu = [
        {
            id: 1,
            menu: "View",
            url: "/dashboard/account/",

        }, 
    ];    

    return (
        <div className="dashboard-main">
            <section className="dashboard-content">
                <DashboardHeader dashboardTitle="Brands" dashboardPreTitle="Products" />
                <table className="styled-table">

                    <thead>
                        <tr >
                            <th>ID</th>
                            <th>Name</th>
                            <th>Date Created</th>
                            <th>Status</th>
                            <th>No of Products</th>
                            <th></th>
                        </tr>
                    </thead>

                    {brands && brands.map(brand => (

                        <tbody key={brand.id}>
                            <tr>
                                <td>{brand.id}</td>
                                <td>{brand.name}</td>
                                {/* <td>{collection.created_at}</td> */}
                                <td>{convertDateTime(brand.created_at)}</td>
                                {brand.is_active?
                                <td>Active</td>
                                :
                                <td>Inactive</td>
                                }

                                <td>{brand.count}</td>
                                {/* <td className='styled-table-menu'>
                                    <ThreeDotsMenu data={collection} threeSubMenu={threeSubMenu} />

                                </td> */}
                            </tr>
                        </tbody>
                    ))}

                </table>


                <Pagination 
                    className="custom-mui-pagination"
                    count={pagecount} 
                    page={page} 
                    onChange={handlePageChange} 
                />

                {isModalOpen &&
                <BrandNew 
                    isModalOpen={isModalOpen} 
                    setIsModalOpen={setIsModalOpen}
                />
                }

                <Fab 
                    className="fab" 
                    color="primary" 
                    aria-label="add"
                    onClick={()=>{
                        setIsModalOpen(true)
                    }
                    }
                >
                    <AddIcon />
                </Fab> 
            </section>
        </div>
    );
  };
  
  export default Brands;